<template>
  <div class="col-xxl-6 col-xl-12 box-col-6">
    <div class="card">
      <div class="card-header">
        <div class="title">Transactions by day of week</div>
      </div>
      <div class="card-body apex-chart">
        <div id="donutchart">
          <apexchart width="590" type="donut" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useReportStore } from '@/store/driver/report';

const reportStore = useReportStore();

// 使用 computed 計算圓餅圖的 series 和 labels
const series = computed(() => {
  return Object.values(reportStore.reportInfo.transaction_by_day_of_week);
});

const chartOptions = computed(() => ({
  chart: {
    type: 'donut',
  },
  responsive: [
    {
      breakpoint: 1800,
      options: {
        chart: {
          width: 480
        },
        legend: {
          position: 'bottom'
        }
      }
    },
    {
      breakpoint: 1500,
      options: {
        chart: {
          width: 450,
          height: 410
        },
        legend: {
          position: 'bottom'
        }
      }
    },
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 300
        },
        legend: {
          position: 'bottom'
        }
      }
    }],
  colors: ['rgba(5,28,44,1)', 'rgba(138,182,253,1)', 'rgba(132,118,245,1)', 'rgba(82,72,218,1)', 'rgba(153,166,180,1)', 'rgba(4,255,127,1)', 'rgba(5,28,44,1)'],
  labels: Object.keys(reportStore.reportInfo.transaction_by_day_of_week),
  legend: {
    show: true,
    position: 'left',
    horizontalAlign: 'left',
    verticalAlign: 'middle',
    fontSize: '20px',
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val + "%";
      }
    },
    style: {
      fontSize: '18px',
      fontFamily: 'Arial, sans-serif'
    }
  },
  dataLabels: {
    enabled: false,
  }
}));
</script>

<style scoped>
.card{
  min-height: 550px;
}

.title{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
}
</style>